import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/plan/queryOutsourcingPullerPage'

/*运输安排*/
export function plansaveArrange(data) {
  return request({
    url: '/icps/system/sign/basics/plan/saveArrange',
    method: 'post',
    data
  })
}